module.exports = __webpack_public_path__ + "img/0b9b728.jpg";